import { useEffect } from 'react';

import { useMatch } from 'react-router';

import { useNewXpModal } from '@/modals';
import { ModalName } from '@/modals-names';

import { useLeaderboards } from '@/entities/leaderboards/model/store';
import { LeaderboardContestType } from '@/entities/leaderboards/model/types';

import {
  getCloudStorageValue,
  setCloudStorageValue,
} from '@/shared/helpers/cloud-storage';

const ALLOWED_CONTEST_TYPES = [
  LeaderboardContestType.XP,
  LeaderboardContestType.PLAYDECK_GAMES,
  LeaderboardContestType.DAILY_XP_IN_GAME,
];

export const useXPModalNotification = () => {
  const leaderboards = useLeaderboards();

  const { open } = useNewXpModal({
    onClose: () => setCloudStorageValue(ModalName.NewXpModal, 'true'),
  });

  const match = useMatch('/leaderboards/:id');

  const leaderboardId = match?.params ? match.params.id : undefined;

  const leaderboard = leaderboards?.find((l) => l.id.toString() === leaderboardId);

  useEffect(() => {
    if (!leaderboard || !ALLOWED_CONTEST_TYPES.includes(leaderboard.contestType)) {
      return;
    }

    void (async () => {
      const hasShown = await getCloudStorageValue(ModalName.NewXpModal);

      if (!hasShown) open();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!!leaderboard]);
};
